<template>
  <div>
    <RequestModal v-if="showRequestModal" v-on:closeModal="showRequestModal = false"/>
    <section class="bgrdimg pb-12 lg:pb-24">
      <Nav />
      <div class="px-6 lg:px-16 mt-12 text-white lg:mt-24">
        <p class="text-blue-500 font-light text-base lg:text-xl">For Individuals</p>
        <p class="lg:w-2/5 text-3xl mt-4 lg:text-4xl font-bold lg:leading-10">We have numerous products suited for your day to day online activities</p>
        <p class="mt-8 lg:w-2/5 text-lg ">eTranzact offers a variety of products and services that cater for different needs. Whether it be an enterprise or a customer centric solution, we ensure quality, stability and security across our platforms.</p>
      </div>
      <div class="grid-container px-6 lg:px-16 mt-12 py-8">
        <div id="box1" class="box relative">
          <div class="hidden lg:block absolute" style="left: 10px; bottom: 0">
            <img src="../assets/img/products/bankitphone.png" alt="" class="bankitphone" style="max-height: 150px;">
          </div>
          <div class="px-4 py-4 lg:relative lg:py-0 ">
            <div class="pt-4 mt-6 lg:mt-0 lg:w-1/2 lg:absolute lg:right-2 lg:top-8">
              <p class="text-white font-bold text-lg">Bank<span class="font-normal">it</span></p>
              <p class=" text-white mt-2 font-light text-sm lg:text-base">You can now pay boldly with Bankit</p>
              <a class="block icon-cont lg:hidden" target="blank" :href="`${baseURL}/products/BankIT Marketing Brochure.pdf`" download>
                <font-awesome-icon icon="arrow-right" class="inline-block"/>
              </a>
            </div>
          </div>
          <a class="icon-cont hidden lg:block lg:absolute " style="bottom: 10px; right: 10px" target="blank" :href="`${baseURL}/products/BankIT Marketing Brochure.pdf`" download>
            <font-awesome-icon icon="arrow-right" class="inline-block"/>
          </a>
        </div>
        <div id="box2" class="box relative">
          <div class="px-4 py-4 lg:py-0 relative">
            <div class="hidden lg:block lg:mt-0 top-8 left-0 absolute">
              <img src="../assets/img/products/transphone.png" alt="" class="" style="max-height: 150px">
            </div>
            <div class="pt-4 lg:mt-4">
              <img src="../assets/img/products/PocketMoni.svg" alt="" class="logoimg1">
              <p class=" text-blue-900 mt-2 text-sm lg:text-base">Nigeria's favorite wallet and payment platform</p>
              <a target="blank" href="https://www.getpocketmoni.com/" class="block icon-cont lg:hidden">
                <font-awesome-icon icon="arrow-right" class="inline-block"/>
              </a>
            </div>
          </div>
          <a target="blank" href="https://www.getpocketmoni.com/" class="icon-cont hidden lg:block lg:absolute " style="bottom: 10px; right: 10px">
            <font-awesome-icon icon="arrow-right" class="inline-block"/>
          </a>
        </div>
        <div id="box3" class="box relative">
          <div class="absolute hidden lg:block" style="top:100px">
            <img src="../assets/img/products/cloud.svg" alt="" class="mx-auto" style="width: 70%">
          </div>
          <div class="absolute hidden lg:block" style="bottom: 0; left: 0;">
            <img src="../assets/img/products/ebconlaptop.png" alt="" class="" style="height: 200px">
          </div>
          <div class="px-4 py-4 lg:py-0 lg:text-center">
            <div class="pt-4 mt-6 lg:mt-6">
              <img src="../assets/img/products/Group 484.svg" alt="" class="logoimg2">
              <p class="text-white mt-2 text-sm lg:text-base">An all-inclusive payment gateway for direct payment with bank accounts</p>
              <div class="icon-cont lg:hidden">
                <font-awesome-icon icon="arrow-right" class="inline-block"/>
              </div>
            </div>
          </div>
          <div class="icon-cont hidden lg:block lg:absolute " style="bottom: 10px; right: 10px">
            <font-awesome-icon icon="arrow-right" class="inline-block"/>
          </div>
        </div>
        <div id="box4" class="box relative">
          <div class="hidden lg:block absolute lg:w-2/5" style="left:-12px; bottom:-20px">
            <img src="../assets/img/products/Group 488.png" alt="" class="" style="">
          </div>
          <div class="px-4 py-4 lg:relative lg:py-0 lg:pl-0">
            <div class="pt-4 mt-6 lg:mt-12 lg:w-1/2 lg:absolute lg:right-2 lg:top-8">
              <p class="text-white font-bold text-lg">Payoutlet.net</p>
              <p class=" text-white mt-2 text-sm lg:text-base">An easier way to pay bills, send money and top-up your mobile phone.</p>
              <a target="blank" class="icon-cont lg:hidden" :href="`${baseURL}/products/Payoutlet Marketing Brochure.pdf`" download>
                <font-awesome-icon icon="arrow-right" class="inline-block"/>
              </a>
            </div>
          </div>
          <a target="blank" class="icon-cont hidden lg:block lg:absolute " style="bottom: 10px; right: 10px" :href="`${baseURL}/products/Payoutlet Marketing Brochure.pdf`" download>
            <font-awesome-icon icon="arrow-right" class="inline-block"/>
          </a>
        </div>
      </div>
    </section>
    <Subscribe />
    <Footer v-on:showRequest="showRequestModal = true"/>
  </div>
</template>

<script>
import Nav from "@/components/Nav"
import Footer from "@/components/Footer"
import RequestModal from "@/components/RequestModal"
import Subscribe from "@/components/Subscribe"
import baseURL from "@/main"
export default {
  components:{
    Nav, RequestModal, Subscribe,
    Footer
  },
  data(){
    return {
      showRequestModal: false,
      baseURL: baseURL
    }
  }
}
</script>

<style scoped>
/* Modal Styling */
  .l-modal{
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0, 0.3);
  }
  .loading-modal{
    min-height: 350px; 
  }
  .l-modal::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }
  .l-modal::-webkit-scrollbar{
    width: 0px;
    background-color: #F5F5F5;
  }
  /* Modal Styling */

section.bgrdimg{
  background-image: url('../assets/img/apply/Intersection 17 (1).svg');
  background-size: cover;
  background-repeat: no-repeat;

}
.logoimg1{
  width: 120px;
}
.logoimg2{
  width: 150px
}
.box{
  margin-top: 20px;
  /* min-height: 200px; */
}
#box1{
  background-color: #F05B29;
}
#box2{
  background-color: #D1ECFF;
}
#box3{
  background-color: #2484C6;
}
#box4{
  background-color: #4D2B77;
}

.icon-cont{
  margin-top: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
  align-content: center;
  align-items: center;
  background-color: #E8F2F9;
  opacity: 0.8
}
@supports (backdrop-filter: blur(5px)){
  .icon-cont{
    backdrop-filter: blur(5px);
  }
}
@media only screen and (min-width: 1024px){
  .box{
    margin-top: 0;
    transition: 1s;
    cursor: pointer;
  }
  .box:hover{
    /* transform: translateY(-50px); */
    transform: scale(1.05 , 1.05);
  }
  div.grid-container{
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: 200px 300px;
    grid-template-areas: 
        "a a a a b b b b  c c c c"
        "d d d d d d d d c c c c";
    grid-gap: 20px;
  }
  #box1{
    grid-area: a
  }
  #box2{
    grid-area: b
  }
  #box3{
    grid-area: c
  }
  #box4{
    grid-area: d;
  }
  .logoimg2{
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>